import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { GeofenceService } from '@app-asset-config/services/geofence.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GeofenceListingComponent } from '../geofence-listing/geofence-listing.component';
import { GeofenceStackRouting } from '../geofence-stack-router';

@Component({
  selector: 'app-geofence-selection-only-layout',
  templateUrl: './geofence-selection-only-layout.component.html',
  styleUrls: ['./geofence-selection-only-layout.component.scss'],
})
export class GeofenceSelectionOnlyLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('stackHost', { read: ViewContainerRef, static: true }) containerRef!: ViewContainerRef;

  // used to communicate between download report and geofence listing component
  @Input() preSelect: number[] = [];
  @Output() selected = new EventEmitter<number[]>();

  private unsubscribe = new Subject();

  private stackRouting: GeofenceStackRouting;

  constructor(private geofenceService: GeofenceService) {}

  ngOnInit(): void {
    // initing stack routing
    this.stackRouting = new GeofenceStackRouting(this.containerRef);

    // subscribing to navigator observable
    this.geofenceService.navigator.pipe(takeUntil(this.unsubscribe)).subscribe(
      ({ componentRef, options }) => {
        if (options.type == 'pop') {
          this.stackRouting.pop(options.data);
        } else {
          this.stackRouting.show(componentRef, options);
        }
      },
      (err) => {
        console.log('Error occurred, while navigating ' + err);
      }
    );

    this.geofenceService.navigateTo(GeofenceListingComponent, {
      mode: 'multiselect',
      from: 'report',
      preSelect: this.preSelect,
      'output:selected': (result: any) => {
        this.selected.emit(result);
      },
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }
}
